import { FaPlus, FaFileContract, FaSignOutAlt, FaUserEdit, FaTimes, FaFileInvoiceDollar } from 'react-icons/fa';
import { supabase } from './supabaseClient';
import { useNavigate, useLocation } from 'react-router-dom';
import logow from './logow.png'; // Assumi che il logo sia lo stesso o lo aggiorni qui
import './tailwind.css';

// Accetta userRole come prop
export default function SidebarAgenteMenu({ nome, cognome, isOpen, closeSidebar, userRole }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/'; // Reindirizza al login
  };

  const getNavLinkClasses = (path) => {
    const baseClasses = "flex items-center p-4 text-gray-200 hover:bg-miobluhover hover:text-white transition-colors duration-200 cursor-pointer text-base rounded-lg";
    const activeClasses = "bg-miobluhover text-white font-semibold shadow-inner"; // Modificato text-red-500 a text-white per coerenza

    // Logica per determinare se il link è attivo
    let isActive = location.pathname === path;

    // Caso speciale: se la rotta index dell'agente è NuovaPolizza
    // E il path del link è la home dell'agente o la rotta di "Crea Nuova Polizza"
    if (path === '/dashboard/agente' || path === '/dashboard/agente/crea-nuova-polizza') {
      // Controlla se la rotta corrente è esattamente /dashboard/agente
      // O se è esattamente /dashboard/agente/crea-nuova-polizza
      isActive = (location.pathname === '/dashboard/agente' && path === '/dashboard/agente') ||
                 (location.pathname === '/dashboard/agente/crea-nuova-polizza' && path === '/dashboard/agente/crea-nuova-polizza');
                 
      // Se NuovaPolizza è l'indice, il link "Crea Nuova Polizza" dovrebbe essere attivo sia se sei sulla home agente che sulla rotta esplicita.
      // Questo rende la rotta '/dashboard/agente' attiva quando sei su '/dashboard/agente' o '/dashboard/agente/crea-nuova-polizza'
      if (path === '/dashboard/agente' && (location.pathname === '/dashboard/agente' || location.pathname === '/dashboard/agente/crea-nuova-polizza')) {
          isActive = true;
      }
    }


    // ⭐ Per "Le Mie Polizze", si attiva se il path inizia con /dashboard/agente/gestisci-mie-polizze ⭐
    if (path === '/dashboard/agente/gestisci-mie-polizze' && location.pathname.startsWith('/dashboard/agente/gestisci-mie-polizze')) {
        isActive = true;
    }

    return `${baseClasses} ${isActive ? activeClasses : ''}`;
  };

  return (
    <aside className={`fixed top-0 left-0 h-full bg-mioblu text-white shadow-lg transform transition-transform duration-300 ease-in-out z-50
      ${isOpen ? 'translate-x-0 flex flex-col' : '-translate-x-full hidden'}
      w-full md:w-64 md:relative md:translate-x-0 md:flex md:flex-col md:flex-shrink-0 md:h-auto md:shadow-none md:z-auto`}>

      <div className="p-6 pb-4 border-b border-miobluhover text-center relative">
        <img src={logow} alt="Europassistance Logo" className="h-12 mx-auto mb-3" />
        <small className="text-gray-200 block text-sm">BUONGIORNO</small>
        <div className="text-xl font-semibold mt-1">{nome} {cognome}</div>
        <button
          onClick={closeSidebar}
          className="absolute top-4 right-4 text-white text-2xl bg-transparent border-none cursor-pointer p-1 md:hidden"
        >
          <FaTimes />
        </button>
      </div>

      <ul className="list-none p-0 my-4 flex-1 overflow-y-auto" onClick={closeSidebar}>
        <li
          className={getNavLinkClasses('/dashboard/agente')} 
          onClick={() => { navigate('/dashboard/agente'); }}
        >
          <FaPlus className="mr-3 text-lg" /> <span>Crea Nuova Adesione</span>
        </li>

        {/* Le Mie Polizze - FaFileContract */}
        <li
          className={getNavLinkClasses('/dashboard/agente/gestisci-mie-polizze')} 
          onClick={() => { navigate('/dashboard/agente/gestisci-mie-polizze'); }} 
        >
          <FaFileContract className="mr-3 text-lg" /> <span>Le Mie Adesioni</span>
        </li>

        {/* Annulla Adesione */}
<li
  className={getNavLinkClasses('/dashboard/agente/annulla-polizza')} 
  onClick={() => { navigate('/dashboard/agente/annulla-polizza'); }} 
>
  <FaFileInvoiceDollar className="mr-3 text-lg" /> <span>Annulla Adesione</span>
</li>

      </ul>

      {/* Sezione inferiore della sidebar */}
      <div className="p-4 flex flex-col space-y-3 border-t border-miobluhover">
        <button
          className={getNavLinkClasses('/dashboard/agente/profilo').replace('text-gray-200', 'text-white').replace('p-4', 'py-3 px-4')}
          onClick={() => { navigate('/dashboard/agente/profilo'); }}
        >
          <FaUserEdit className="mr-3 text-lg" /> Aggiorna profilo
        </button>
        <button
          className="flex items-center justify-center w-full py-3 px-4 bg-miorosso text-white rounded-md transition-colors duration-200 hover:bg-miorossohover focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="mr-3 text-lg" /> Logout
        </button>
      </div>
    </aside>
  );
}
